import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Truck } from 'lucide-react';

export function DispatchTab({ stillages, onDispatch }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Truck size={20} />Stillages
        </CardTitle>
      </CardHeader>
      <CardContent>
        {stillages.length === 0 ? (
          <div className="h-48 flex items-center justify-center text-muted-foreground">No stillages created</div>
        ) : (
          <div className="space-y-3">
            {stillages.map(function(s) {
              var bgClass = s.status === 'dispatched' ? 'bg-gray-50 border-gray-200' : 'bg-white border-orange-200';
              var badgeClass = s.status === 'dispatched' ? 'bg-gray-100 text-gray-500' : 'bg-yellow-100 text-yellow-700';
              return (
                <div key={s.id} className={'p-3 rounded border ' + bgClass}>
                  <div className="flex justify-between items-center">
                    <div>
                      <span className="font-mono font-medium">{s.stillage_number}</span>
                      <span className="ml-2 text-sm text-muted-foreground">{s.item_count} items</span>
                    </div>
                    <span className={'px-2 py-1 rounded text-xs ' + badgeClass}>{s.status}</span>
                  </div>
                  {s.status !== 'dispatched' && (
                    <Button variant="outline" size="sm" className="mt-2 w-full" onClick={function() { onDispatch(s.id); }}>
                      <Truck size={14} className="mr-1" />Dispatch
                    </Button>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
